import { createApp } from 'vue'
import i18next from 'i18next'
import I18NextVue from 'i18next-vue'

import CoinTransactionsList from '../pages/CoinTransactionsList.vue'

class ProfileMyPointComponent {
  constructor({ container }) {
    this.app = null
    this.container = container
  }

  init() {
    if (this.container !== '#coin-transactions-app') {
      console.error('Invalid container ID for ProfileMyPointComponent')
      return
    }

    this.app = createApp(CoinTransactionsList)
    this.app.use(I18NextVue, { i18next })
    this.app.mount(this.container)
  }
}

export default ProfileMyPointComponent
